import "./Admin-login.css";
import React, { useState, useEffect, useCallback, useRef } from "react";
import ThemeSwitch from "../../Components/themeSwitch/themeSwitch";
import OTPInputWithTimer from "../../Components/OTPInput/otpInputField";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setUsername, setUserIdStore } from "../../Redux/store/userSlice";
import { debounce } from "lodash";
import WebSocketComponent from "./websocket";
import CustomerLeftPanel from "../../Components/CustomerLeftPanel/customer-left-panel";
import { changeCardFalse } from "../../Redux/store/selectedCard";
import { useToast } from "../../Utils/toastContext";
import { initializeTokens } from "../../Utils/tokenManager";
import { syncAccountRestriction } from "../../Utils/syncAccountRestriction";
import { resetPlatformNoticeSession } from "../../Utils/platformNoticeSession";
import { motion, AnimatePresence } from "framer-motion";
import ResendOptions from "../../Components/OTPInput/resent-auth-code";

const AdminLogin = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const { showToast } = useToast();
  const intervalRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [isRecoveryCodeOption, setIsRecoveryCodeOption] = useState(false);
  const [isAuthCode, setIsAuthCode] = useState(false);
  const [handshakeApproved, sethandshakeApproved] = useState(false);
  const [emailVerfied, setEmailVerfied] = useState(false);
  const [userId, setUserId] = useState(null);
  const [sessionId, setSessionId] = useState(null);
  const [otp, setOtp] = useState("");
  const [authAppCode, setAuthAppCode] = useState("");
  const [authCode, setAuthCode] = useState(new Array(6).fill(""));
  const [maskedMobile, setMaskedMobile] = useState("");
  const [selectedOption, setSelectedOption] = useState(1);
  const [showAppPopup, setShowAppPopup] = useState(false);
  const [androidImage, setAndroidImage] = useState("");
  const [IOSImage, setIOSImage] = useState("");

  const dispatch = useDispatch();
  const location = useLocation();
  const handlePaste = (event) => {
    const pasteData = event.clipboardData.getData("text").slice(0, 6);
    if (/^\d{6}$/.test(pasteData)) {
      setAuthCode(pasteData.split(""));
    }
    event.preventDefault();
  };
  useEffect(() => {
    const { passwordReset } = location.state || {};
    if (passwordReset) {
      showToast("Password Reset Successful!", "success");
      navigate(location.pathname, { replace: true });
    }
  }, [location.state]);
  const options = [
    {
      id: 1,
      label: `${maskedMobile}`,
      checkedIcon: "/tick-circle-blue.svg",
      uncheckedIcon: "/tick-empty-blue.svg",
      secondImage: "/mobile.svg",
      name: "Mobile Number",
    },
    {
      id: 2,
      label: `${email}`,
      checkedIcon: "/tick-circle-blue.svg",
      uncheckedIcon: "/tick-empty-blue.svg",
      secondImage: "/sms.svg",
      name: "Email",
    },
    {
      id: 3,
      label: "Recovery Code [ONE TIME USE]",
      checkedIcon: "/tick-circle-blue.svg",
      uncheckedIcon: "/tick-empty-blue.svg",
      secondImage: "/lock.svg",
      name: "Recovery Code",
    },
  ];
  const navigate = useNavigate();

  const handleChange = (id) => {
    setSelectedOption(id);
  };

  const handletryAuthCode = (e) => {
    e.preventDefault();
    setIsAuthCode(true);
  };
  const handletryRecoveryCode = (e) => {
    e.preventDefault();
    setIsAuthCode(false);
    setIsRecoveryCodeOption(true);
  };
  const togglePassword = () => {
    setShowPassword((prevState) => !prevState);
  };
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  const postLoginAPI = async (email, password) => {
    const apiUrl = `${BASE_URL}/v1/auth/login`; 
    // const apiUrl = 'http://127.0.0.1:8002/api/v1/auth/login'
    const bodyData = {
      email_address: email,
      password: password,
    };

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const GetAPIcalls = async (url) => {
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      "Content-Type": "application/json",
    };

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
          status: response.status,
        }));

        // Ensure errorData.message is extracted properly
        const errorMessage =
          typeof errorData === "object" && errorData.message
            ? errorData.message
            : `Error ${response.status}: ${response.statusText}`;

        throw new Error(errorMessage);
      }

      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  const getQRImages = async () => {
    try {
      const response = await GetAPIcalls(`/v1/settings/app-qr-codes`);
      if (response.status == 200) {
        setAndroidImage(response.data.android);
        setIOSImage(response.data.ios);
        setTimeout(() => {
          setShowAppPopup(true);
          setFormSubmitted(true);
        }, 700);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          showToast(response.message, "error");
        }
      }
    } catch (err) {
      if (err.status === 401) {
        localStorage.removeItem("jwtToken");
        navigate("/login");
        setShowAppPopup(false);
      }
      showToast(err.message, "error");
    } finally {
    }
  };
  useEffect(() => {
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, []);
  const handleSubmit = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await postLoginAPI(email, password);
        if (response.status === 200) {
          console.log("Login successful");
          setUserId(response.data.user_id);
          setSessionId(response.data.session_id);
          setMaskedMobile(response.data.masked_phone_number);
// <<<<<<< HEAD
//           setFormSubmitted(true);
//           setAuthAppCode(response.data.code);
// =======
// >>>>>>> onboarding-corporate
          //for auth code
          localStorage.setItem("jwtToken",response.data.code);
          if (response.data.totp_enabled) {
            //getQRImages();
            setFormSubmitted(true);
            sethandshakeApproved(true);
            if (intervalRef.current) clearInterval(intervalRef.current);
            // Start calling every 60 seconds
          } else {
            getQRImages();
          }
          //end here
        }
      } catch (error) {
        toastMessage = { message: error.message, type: "error" };
        setFormSubmitted(false);
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000),
    [email, password] // Dependencies
  );
  useEffect(() => {
    if (userId && sessionId) {
      GetAuthCode(userId, sessionId);
    }
  }, [userId, sessionId]);
  const PostAuthCode = async (userId, sessionId) => {
    const apiUrl = `${BASE_URL}/v1/auth/create-auth-code`; 
    const bodyData = {
      user_id: userId,
      session_id: sessionId,
    };

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const GetAuthCode = useCallback(
    debounce(async () => {
      let toastMessage = null;
      try {
        const response = await PostAuthCode(userId, sessionId);
        if (response.status === 200) {
          setAuthAppCode(response.data.code);
          setFormSubmitted(true);
        }
      } catch (error) {
        toastMessage = { message: error.message, type: "error" };
        setFormSubmitted(false);
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000),
    [userId, sessionId] // Dependencies
  );
  const postLoginSubmitted = async (userId, otp) => {
    let methodId = options.find((o) => o.id === selectedOption).id;
    const apiUrl =
      methodId == 1
        ? `${BASE_URL}/v1/auth/verify-mfa-sms`
        : `${BASE_URL}/v1/auth/verify-mfa-email`;
    const bodyData = {
      user_id: userId,
      code: otp,
      purpose: "login",
    };

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handleSubmitMobile = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null; // Store the toast message

      try {
        const response = await postLoginSubmitted(userId, otp);
        if (response.status == 200) {
          // Create user info object for storage
          const userInfo = {
            userId: response.data.user_id,
            firstName: response.data.first_name,
            lastName: response.data.last_name,
            fullName: response.data.first_name + " " + response.data.last_name,
            email: response.data.email_address || "",
            role: response.data.role || "",
          };

          // Initialize token manager with user data
          initializeTokens(
            response.data.access_token,
            response.data.refresh_token,
            userInfo
          );

          // Update Redux store
          dispatch(
            setUsername(
              response.data.first_name + " " + response.data.last_name
            )
          );
          dispatch(setUserIdStore(response.data.user_id));

          syncAccountRestriction(dispatch, response.data);

          resetPlatformNoticeSession();

          // Set standard token variables for backward compatibility
          localStorage.setItem("jwtToken", response.data.access_token);
          localStorage.setItem("refreshJwtToken", response.data.refresh_token);
          localStorage.setItem("systemToken", response.data.session_id?response.data.session_id:"");
          localStorage.setItem("sideOption", 1);
          dispatch(changeCardFalse());

          const savedRedirect = sessionStorage.getItem("redirectAfterLogin");
          if (savedRedirect) {
            const { path, state } = JSON.parse(savedRedirect);
            navigate(path, { state });
            sessionStorage.removeItem("redirectAfterLogin");
          } else {
            navigate("/");
          }
        } else {
          toastMessage = { message: response.message, type: "error" };
          return;
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
        return;
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000),
    [otp, userId] // Dependencies
  );
  const postSubmitAuthAppCode = async (userId, sessionId, authCode) => {
    const apiUrl = `${BASE_URL}/v1/auth/verify-totp`;
    const bodyData = {
      user_id: userId,
      session_id: sessionId,
      totp_code: authCode.join(""),
    };

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handleSubmitAuthAppCode = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null; // Store the toast message

      try {
        const response = await postSubmitAuthAppCode(
          userId,
          sessionId,
          authCode
        );
        if (response.status == 200) {
          dispatch(
            setUsername(
              response.data.first_name + " " + response.data.last_name
            )
          );
          localStorage.setItem("jwtToken", response.data.access_token);
          localStorage.setItem("refreshJwtToken", response.data.refresh_token);
          localStorage.setItem("systemToken", response.data.session_id?response.data.session_id:"");
          localStorage.setItem("sideOption", 1);
          dispatch(changeCardFalse());
          syncAccountRestriction(dispatch, response.data);

          resetPlatformNoticeSession();

          const savedRedirect = sessionStorage.getItem("redirectAfterLogin");
          if (savedRedirect) {
            const { path, state } = JSON.parse(savedRedirect);
            navigate(path, { state });
            sessionStorage.removeItem("redirectAfterLogin");
          } else {
            navigate("/");
          }
        } else {
          toastMessage = { message: response.message, type: "error" };
          return;
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
        return;
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000),
    [authCode, sessionId, userId] // Dependencies
  );
  const sendCodeToverify = async (userId) => {
    let methodId = options.find((o) => o.id === selectedOption).id;

    const apiUrl = `${BASE_URL}/api/v1/auth/send-mfa-code`;
    const bodyData = {
      user_id: userId,
      purpose: "login",
      method: methodId == 1 ? "sms" : "email",
    };

    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const SendCode = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null; // Store the toast message
      let methodId = options.find((o) => o.id === selectedOption).id;
      if (methodId != 3) {
        try {
          const response = await sendCodeToverify(userId);
          if (response.status == 200) {
            toastMessage = {
              message: "OTP sent successfully!",
              type: "success",
            };
            setEmailVerfied(true);
          } else {
            toastMessage = { message: response.message, type: "error" };
            setEmailVerfied(false);
            return;
          }
        } catch (err) {
          toastMessage = { message: err.message, type: "error" };
        } finally {
          setLoading(false); // Ensure `loading` is false first
          // Show toast after loading is false
          if (toastMessage) {
            setTimeout(() => {
              showToast(toastMessage.message, toastMessage.type);
            }, 300); // Small delay if needed
          }
        }
      } else {
        setIsRecoveryCodeOption(true);
      }
    }, 1000),
    [userId, selectedOption] // Dependencies
  );
  // Handle backspace
  const handleKeyDown = (event, index) => {
    if (event.key === "Backspace" && !authCode[index] && index > 0) {
      document.getElementById(`code-input-${index - 1}`).focus();
    }
  };

  const handleChangeAuthCode = (value, index) => {
    if (/^\d*$/.test(value)) {
      // Only allow numbers
      const newOtp = [...authCode];
      newOtp[index] = value;
      setAuthCode(newOtp);
      if (value && index < 5) {
        document.getElementById(`code-input-${index + 1}`).focus();
      }
    }
  };
  const handleGuestLogin = () => {
    // You can redirect, open a limited guest view, or show a warning
    navigate("/add-stocks-guest"); // or open modal with guest info
  };
  const handleAppLogin = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null; // Store the toast message

      try {
        setFormSubmitted(false);
        setEmail("");
        setPassword("");
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
        return;
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000),
    [otp, userId] // Dependencies
  );
  return (
    <div className="flex  flex-col lg:flex-row h-screen dark:bg-[#101010] bg-[#FFFFFF]">
      <CustomerLeftPanel />
      <div className="w-full right-div lg:w-2/5 flex flex-col">
        <ThemeSwitch />
        {loading && (
          <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
            <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
          </div>
        )}
        {formSubmitted ? (
          <div>
            {emailVerfied &&
              !showAppPopup &&
              !isRecoveryCodeOption &&
              !handshakeApproved && (
                <div className="flex  flex-col mt-10 justify-center items-center md:p-0 p-10 justify">
                  <h2 className="text-2xl mb-[32px] dark:text-white font-medium mb-6">
                    Please Verify your{" "}
                    {options.find((o) => o.id === selectedOption).name}
                  </h2>

                  <form
                    className="w-full max-w-sm"
                    onSubmit={(e) => {
                      e.preventDefault();
                      if (otp.length < 6) {
                        showToast("Please Enter 6 digit OTP!", "error"); // Success toast
                        return;
                      }
                      setLoading(true);
                      handleSubmitMobile(e);
                    }}
                  >
                    <p className="text-sm mb-[32px] dark:text-white font-medium mb-6">
                      Please check your{" "}
                      {options.find((o) => o.id === selectedOption).name} for
                      the verification code we just sent you and enter the code
                      in the box below
                    </p>
                    <div className="mb-2">
                      <label
                        htmlFor="maskedData"
                        className="block dark:text-gray-300 font-normal color-test text-md mb-1"
                      >
                        Code sent to:
                      </label>
                      <input
                        id="maskedData"
                        name="maskedData"
                        type="text"
                        value={`${
                          options.find((o) => o.id === selectedOption).label
                        }`}
                        required={true}
                        disabled={true}
                        className="input-field disabled-text dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3 leading-tight focus:outline-none focus:shadow-outline"
                      />
                    </div>
                    <div className="mb-4 mt-10">
                      <OTPInputWithTimer
                        onOtpChange={(value) => setOtp(value)}
                        onLoadingChange={(value) => setLoading(value)}
                        initialTime={300}
                        userId={userId}
                        postCode={SendCode}
                      />
                    </div>

                    <button
                      type="submit"
                      className="w-full dark:bg-[#424242] dark:hover:bg-[#424242e6] bg-black text-white rounded-full text-white font-medium text-md py-3 flex items-center justify-center gap-2 hover:bg-white-600 transition duration-300"
                    >
                      Submit
                    </button>
                  </form>
                </div>
              )}
            {!isAuthCode &&
              !showAppPopup &&
              isRecoveryCodeOption &&
              !handshakeApproved && (
                <div className="flex  flex-col mt-10 justify-center items-center md:p-0 p-10 justify">
                  <h2 className="text-2xl mb-[32px] dark:text-white font-medium mb-6">
                    Log in to Caprock
                  </h2>

                  <form
                    className="w-full max-w-sm "
                    onSubmit={handleSubmitMobile}
                  >
                    <p className="text-sm  dark:text-white ">
                      Enter a recovery code to access your account. Recovery
                      codes are used when your phone is unavailable, and each
                      code can only be used once.
                    </p>
                    <div className="flex font-medium items-center w-full max-w-sm px-4 ml-16 py-2 space-x-2">
                      <img
                        src="/sms.svg"
                        alt="Success Icon"
                        className="h-6 w-6"
                      />
                      <p className="text-sm text-left text-[#888888] dark:text-white font-medium">
                        {email}
                      </p>
                    </div>
                    <div className="flex w-full flex-col items-center justify-between">
                      <div
                        onPaste={handlePaste}
                        className="flex w-full gap-2 mb-2 mt-8 flex-nowrap justify-between"
                      >
                        {authCode.map((digit, index) => (
                          <input
                            key={index}
                            id={`code-input-${index}`}
                            type="text"
                            maxLength="1"
                            value={digit}
                            onChange={(e) =>
                              handleChangeAuthCode(e.target.value, index)
                            }
                            onKeyDown={(e) => handleKeyDown(e, index)}
                            className={`w-10 h-10 sm:w-14 sm:h-14 md:w-14 md:h-14
          dark:bg-[#101010] ${
            digit ? "border-[#003478]" : "grey"
          } dark:border-[#4F4F4F] appearance-none border-2 rounded py-2 px-3  dark:focus-visible:ring-[#4E4E4E] dark:text-white  text-black text-base font-medium leading-tight focus:outline-none focus:shadow-outline
          input-main`}
                          />
                        ))}
                      </div>
                    </div>
                    <button
                      type="submit"
                      className="w-full mt-10  bg-[#003478] rounded-full text-white font-medium text-md py-3 rounded flex items-center justify-center gap-2 transition duration-300"
                    >
                      Submit
                    </button>
                  </form>
                </div>
              )}
            {!emailVerfied &&
              !isRecoveryCodeOption &&
              !isAuthCode &&
              !handshakeApproved &&
              !showAppPopup && (
                <div className="flex  flex-col mt-10 justify-center items-center md:p-0 p-10 justify">
                  <h2 className="text-2xl mb-[32px] dark:text-white font-medium mb-6">
                    Log in to Caprock
                  </h2>
                  <form
                    className="w-full max-w-sm"
                    onSubmit={(e) => {
                      e.preventDefault();
                      setLoading(true);
                      SendCode(e);
                    }}
                  >
                    <div className="mb-4">
                      <label
                        htmlFor="maskedMobile"
                        className="block dark:text-gray-300 font-normal color-test text-md mb-1"
                      >
                        {options.find((o) => o.id === selectedOption).name}
                      </label>
                      <input
                        id="maskedMobile"
                        name="maskedMobile"
                        type="text"
                        value={`${
                          options.find((o) => o.id === selectedOption).label
                        }`}
                        required={true}
                        disabled={true}
                        className="input-field dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3 leading-tight focus:outline-none focus:shadow-outline"
                        onChange={(e) => setMaskedMobile(e.target.value)}
                      />
                      <div className="mt-4 text-md font-medium">
                        <p>Authentication</p>
                        <ul className="space-y-2">
                          {options.map((option) => (
                            <li
                              key={option.id}
                              className="flex items-center pt-5 cursor-pointer"
                              onClick={() => handleChange(option.id)}
                            >
                              <img
                                src={
                                  selectedOption === option.id
                                    ? option.checkedIcon
                                    : option.uncheckedIcon
                                }
                                alt={
                                  selectedOption === option.id
                                    ? "Checked"
                                    : "Unchecked"
                                }
                                className="w-6 h-6 mr-4"
                              />
                              <img
                                src={option.secondImage}
                                alt={
                                  selectedOption === option.id
                                    ? "Checked"
                                    : "Unchecked"
                                }
                                className="w-4 h-4 mr-4"
                              />
                              <span>{option.label}</span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                    <button
                      type="submit"
                      className="w-full mt-10 dark:bg-[#424242] dark:hover:bg-[#424242e6] bg-black text-white rounded-full font-medium text-md py-3  flex items-center justify-center gap-2 hover:bg-white-600 transition duration-300"
                    >
                      Get Code
                    </button>
                  </form>
                </div>
              )}
            {isAuthCode && handshakeApproved && !showAppPopup && (
              <div className="flex  flex-col mt-10 justify-center items-center md:p-0 p-10 justify">
                <h2 className="text-2xl mb-[32px] dark:text-white font-medium mb-6">
                  Log in to Caprock
                </h2>

                <form
                  className="w-full max-w-sm "
                  onSubmit={(e) => {
                    e.preventDefault();
                    if (authCode.join("").length < 6) {
                      showToast("Please Enter 6 digit Number!", "error"); // Success toast
                      return;
                    }
                    setLoading(true);
                    handleSubmitAuthAppCode(e);
                  }}
                >
                  <p className="text-sm  dark:text-white ">
                    Enter the number displayed on the homepage of your Caprock
                    mobile app in the authentication section.
                  </p>
                  <div className="flex font-medium items-center w-full max-w-sm px-4 ml-16 py-2 space-x-2">
                    <img
                      src="/sms.svg"
                      alt="Success Icon"
                      className="h-6 w-6"
                    />
                    <p className="text-sm text-left text-[#888888] dark:text-white font-medium">
                      {email}
                    </p>
                  </div>
                  <div className="flex w-full flex-col items-center justify-between">
                    <div
                      onPaste={handlePaste}
                      className="flex w-full gap-2 mb-2 mt-8 flex-nowrap justify-between"
                    >
                      {authCode.map((digit, index) => (
                        <input
                          key={index}
                          id={`code-input-${index}`}
                          type="text"
                          maxLength="1"
                          value={digit}
                          onChange={(e) =>
                            handleChangeAuthCode(e.target.value, index)
                          }
                          onKeyDown={(e) => handleKeyDown(e, index)}
                          className={`w-10 h-10 sm:w-14 sm:h-14 md:w-14 md:h-14
            dark:bg-[#101010] ${
              digit ? "border-[#003478]" : "grey"
            } dark:border-[#4F4F4F] appearance-none border-2 rounded py-2 px-3  dark:focus-visible:ring-[#4E4E4E] dark:text-white  text-black text-base font-medium leading-tight focus:outline-none focus:shadow-outline
            input-main`}
                        />
                      ))}
                    </div>
                  </div>

                  {/* "Didn't get a code?" Section */}
                  <div className="flex items-center pt-4  mb-6 justify-between mb-6">
                    <div className="flex items-center"></div>
                    <a
                      href="#"
                      onClick={(e) => handletryRecoveryCode(e)}
                      className=" text-sm font-semibold text-decoration after-login hover:underline"
                    >
                      Use your Recovery Code
                    </a>
                  </div>
                  <button
                    type="submit"
                    className="w-full dark:bg-[#424242] dark:hover:bg-[#424242e6] bg-black text-white rounded-full text-white font-medium text-md py-3 flex items-center justify-center gap-2 hover:bg-white-600 transition duration-300"
                  >
                    Submit
                  </button>
                </form>
              </div>
            )}
            <AnimatePresence>
              {handshakeApproved &&
                !emailVerfied &&
                !isRecoveryCodeOption &&
                !isAuthCode &&
                !showAppPopup && (
                  <motion.div
                    key="caprock-popup"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: 20 }}
                    transition={{ duration: 0.4 }}
                    className="flex flex-col mt-10 justify-center items-center md:p-0 p-10"
                  >
                    <div className="flex  flex-col mt-10 justify-center items-center md:p-0 p-10 justify">
                      <h2 className="text-2xl mb-[32px] dark:text-white font-medium mb-6">
                        Approve your Sign in
                      </h2>
                      <WebSocketComponent userId={userId} />

                      <form
                        className="w-full max-w-sm "
                        onSubmit={handleSubmitMobile}
                      >
                        <p className="text-sm  dark:text-white ">
                          Use the number you see below in your Caprock Mobile
                          App to sign in
                        </p>
                        <div className="flex font-medium items-center w-full max-w-sm px-4 ml-16 py-2 space-x-2">
                          <img
                            src="/sms.svg"
                            alt="Success Icon"
                            className="h-6 w-6"
                          />
                          <p className="text-sm text-left text-[#888888] dark:text-white font-medium">
                            {email}
                          </p>
                        </div>
                        <div className="mt-6 mb-4 w-full max-w-sm  text-center text-4xl font-semibold text-black dark:text-white">
                          <span className="bg-[#F9F9F9] px-4 py-2 rounded">
                            {authAppCode}
                          </span>
                        </div>

                        {/* "Didn't get a code?" Section */}
                        <p className="text-md w-full max-w-sm text-center text-black font-medium">
                          Didn't get a code?
                        </p>
                        <div className="text-center w-full max-w-sm mt-4 space-y-3">
                          <a
                            href="#"
                            onClick={(e) => handletryAuthCode(e)}
                            className="text-sm text-[#003478] font-semibold underline block"
                          >
                            Try your Authentication Code Instead
                          </a>

                          <span className="text-black font-medium block">
                            -or-
                          </span>

                          <a
                            href="#"
                            onClick={(e) => handletryRecoveryCode(e)}
                            className="text-sm text-[#9C9C9C] font-semibold underline block"
                          >
                            Use your Recovery Code
                          </a>
                        </div>

                        <ResendOptions
                          handleResendCode={GetAuthCode}
                          autoStart={true}
                        />
                      </form>
                    </div>
                  </motion.div>
                )}
            </AnimatePresence>

            {!isAuthCode &&
              isRecoveryCodeOption &&
              handshakeApproved &&
              !showAppPopup &&
              !emailVerfied && (
                <div className="flex  flex-col mt-10 justify-center items-center md:p-0 p-10 justify">
                  <h2 className="text-2xl mb-[32px] dark:text-white font-medium mb-6">
                    Log in to Caprock
                  </h2>

                  <form
                    className="w-full max-w-sm "
                    onSubmit={handleSubmitMobile}
                  >
                    <p className="text-sm  dark:text-white ">
                      Enter a recovery code to access your account. Recovery
                      codes are used when your phone is unavailable, and each
                      code can only be used once.
                    </p>
                    <div className="flex font-medium items-center w-full max-w-sm px-4 ml-16 py-2 space-x-2">
                      <img
                        src="/sms.svg"
                        alt="Success Icon"
                        className="h-6 w-6"
                      />
                      <p className="text-sm text-left text-[#888888] dark:text-white font-medium">
                        {email}
                      </p>
                    </div>
                    <div className="flex w-full flex-col items-center justify-between">
                      <div
                        onPaste={handlePaste}
                        className="flex w-full gap-2 mb-2 mt-8 flex-nowrap justify-between"
                      >
                        {authCode.map((digit, index) => (
                          <input
                            key={index}
                            id={`code-input-${index}`}
                            type="text"
                            maxLength="1"
                            value={digit}
                            onChange={(e) =>
                              handleChangeAuthCode(e.target.value, index)
                            }
                            onKeyDown={(e) => handleKeyDown(e, index)}
                            className={`w-10 h-10 sm:w-14 sm:h-14 md:w-14 md:h-14
          dark:bg-[#101010] ${
            digit ? "border-[#003478]" : "grey"
          } dark:border-[#4F4F4F] appearance-none border-2 rounded py-2 px-3  dark:focus-visible:ring-[#4E4E4E] dark:text-white  text-black text-base font-medium leading-tight focus:outline-none focus:shadow-outline
          input-main`}
                          />
                        ))}
                      </div>
                    </div>
                    <button
                      type="submit"
                      className="w-full mt-10  bg-[#003478] rounded-full text-white font-medium text-md py-3 rounded flex items-center justify-center gap-2 transition duration-300"
                    >
                      Submit
                    </button>
                  </form>
                </div>
              )}
            <AnimatePresence>
              {!emailVerfied &&
                !isRecoveryCodeOption &&
                !isAuthCode &&
                !handshakeApproved &&
                showAppPopup && (
                  <motion.div
                    key="caprock-popup"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: 20 }}
                    transition={{ duration: 0.4 }}
                    className="flex flex-col mt-10 justify-center items-center md:p-0 p-10"
                  >
                    <h2 className="text-2xl mb-[32px] dark:text-white font-medium mb-6">
                      Download Caprock Mobile Application.
                    </h2>

                    <form className="w-full max-w-sm" onSubmit={handleAppLogin}>
                      <p className="text-sm mb-[32px] dark:text-white font-medium mb-6">
                        Please scan the below QR code to Download the Caprock
                        Authenticator App & Register for easy access.
                      </p>

                      <div className="flex flex-col md:flex-row items-center justify-center gap-6">
                        {/* iOS QR Code */}
                        <div className="flex flex-col items-center">
                          <div className="flex items-center max-w-fit gap-1 border-2 border-black rounded-lg pr-6 pl-2 py-1 bg-white dark:bg-black">
                            <img
                              src="/apple-logo.svg"
                              alt="iOS QR Code"
                              className="w-4 h-4"
                            />
                            <div className="flex flex-col leading-tight">
                              <p className="text-[10px] text-black whitespace-nowrap">
                                Download on the
                              </p>
                              <p className="text-md font-semibold text-black whitespace-nowrap">
                                App Store
                              </p>
                            </div>
                          </div>
                          <a
                            href={IOSImage}
                            className=" mt-2"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              src={IOSImage}
                              alt="App Store"
                              className="w-36 mt-1"
                            />
                          </a>
                        </div>

                        <p className="text-sm text-labelColour font-medium">
                          Scan the QR Code
                        </p>

                        {/* Android QR Code */}
                        <div className="flex flex-col items-center">
                          <div className="flex items-center max-w-fit gap-1 border-2 border-black rounded-lg pr-6 pl-2 py-1 bg-white dark:bg-black">
                            <img
                              src="/playstore-logo.svg"
                              alt="Android QR Code"
                              className="w-4 h-4"
                            />
                            <div className="flex flex-col leading-tight">
                              <p className="text-[10px] text-black whitespace-nowrap">
                                Get It On
                              </p>
                              <p className="text-md font-semibold text-black whitespace-nowrap">
                                Google Play
                              </p>
                            </div>
                          </div>
                          <a
                            href={androidImage}
                            className="mt-2"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              src={androidImage}
                              alt="Play Store"
                              className="w-36 mt-1"
                            />
                          </a>
                        </div>
                      </div>

                      <button
                        type="submit"
                        className="w-full mt-10 dark:bg-[#424242] dark:hover:bg-[#424242e6] bg-black rounded-full text-white font-medium text-md py-3 flex items-center justify-center gap-2 hover:bg-white-600 transition duration-300"
                      >
                        Continue
                      </button>
                    </form>
                  </motion.div>
                )}
            </AnimatePresence>
          </div>
        ) : (
          <div>
            <div className="flex  flex-col mt-10 justify-center items-center md:p-0 p-10 justify">
              <h2 className="text-2xl mb-[32px] dark:text-white font-medium mb-6">
                Log in to Caprock
              </h2>
              <form
                className="w-full max-w-sm"
                onSubmit={(e) => {
                  e.preventDefault();
                  if (!validateEmail(email)) {
                    showToast("Please Enter a Valid email!", "error");
                    return;
                  }
                  setLoading(true);
                  handleSubmit(e);
                }}
              >
                <div className="mb-4">
                  <label
                    htmlFor="email"
                    className="block dark:text-gray-300 font-normal color-test text-md mb-1"
                  >
                    Email
                  </label>
                  <input
                    id="email"
                    name="email"
                    type="text"
                    value={email}
                    required={true}
                    placeholder="name@gmail.com"
                    className="input-field dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3 leading-tight focus:outline-none focus:shadow-outline"
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
                <div className="mb-4 relative">
                  <label
                    htmlFor="password"
                    className="block color-test dark:text-gray-300 font-normal color-test text-md mb-1"
                  >
                    Password
                  </label>
                  <input
                    type={showPassword ? "text" : "password"}
                    value={password}
                    required={true}
                    id="password"
                    onChange={(e) => setPassword(e.target.value)}
                    className="dark:bg-[#101010] dark:border-[#4F4F4F] input-field appearance-none border w-full py-2 px-3  dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium leading-tight focus:outline-none focus:shadow-outline"
                    placeholder="Type password"
                  />
                  <button
                    type="button"
                    onClick={togglePassword}
                    className="absolute right-3 set-top"
                  >
                    {" "}
                    {showPassword ? (
                      <img src="/eye.svg" alt="Logo" className="h-auto" />
                    ) : (
                      <img src="/eye-slash.svg" alt="Logo" className="h-auto" />
                    )}
                  </button>
                  <div className="flex items-center pt-4 justify-between mb-6">
                    <div className="flex items-center"></div>
                    <a
                      onClick={() => navigate("/forgot-password")}
                      href="#"
                      className=" text-sm font-medium  after-login hover:underline"
                    >
                      Forgot Password?
                    </a>
                  </div>
                </div>
                <button
                  type="submit"
                  className="w-full dark:bg-[#424242] dark:hover:bg-[#424242e6] bg-black text-white rounded-full text-white font-medium text-md py-3  flex items-center justify-center gap-2 hover:bg-white-600 transition duration-300"
                >
                  <img
                    src="/profile-circle-white.svg"
                    alt="Login Icon"
                    className="h-6 w-6"
                  />
                  Login
                </button>
              </form>
              <div className="mt-6 w-full max-w-sm text-center">
                <img src="/line.svg" alt="Logo" className="h-auto" />

                <p className="text-labelColour dark:text-[#CCCCCC] font-medium pt-2">
                  Don't have an account?{" "}
                  <button
                    type="submit"
                    disabled={false}
                    onClick={() => {
                      window.location.href =
                        "https://map.merchant.caprock.com.au/sign-up";
                     // navigate("/sign-up");
                    }}
                    className="w-full dark:bg-[#101010] dark:text-white dark:border-[#424242] mt-2 signup-button text-black font-medium text-sm py-3 rounded flex items-center justify-center gap-2 hover:bg-[#F1F5F9] dark:hover:bg-[#1E293B]  transition duration-300"
                  >
                    <img
                      src="/user-circle-add.svg"
                      alt="Login Icon"
                      className="h-6 w-6 dark:hidden"
                    />
                    Sign up
                  </button>
                  <div className="mt-4 w-full max-w-sm text-center">
                    <button
                      type="button"
                      onClick={handleGuestLogin}
                      className="w-full bg-white dark:bg-[#2a2a2a] dark:hover:bg-[#3a3a3a] hover:bg-[#f3f4f6] border border-gray-400 dark:border-[#424242] text-black dark:text-white font-medium text-sm py-3 rounded-full flex items-center justify-center gap-2 transition duration-300"
                    >
                      <img
                        src="/guest-icon.svg" // Replace with your guest icon
                        alt="Guest Icon"
                        className="h-5 w-5"
                      />
                      Continue as Guest
                    </button>
                  </div>
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminLogin;
